
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingPages/DecorSubLandingPage",
      function () {
        return require("private-next-pages/landingPages/DecorSubLandingPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingPages/DecorSubLandingPage"])
      });
    }
  